// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__U+eBr","input":"Input_input__u-0q4","full-width":"Input_full-width__l6P8x","icon":"Input_icon__86zKm","gray":"Input_gray__ttoaV"};